export default {
  app: {
    notFound: {
      title: 'Page not found.',
      subtitle: 'It looks like you got lost.',
      text: 'Don’t worry, we will help you navigate from here',
    },
  },
};
